<template>
<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
    <div class="my-account-title">Account Information</div>
    <div class="account_section_box">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <label class="account_label">Account ID:</label>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                <p class="account_p">{{AccountEdit.evfAccountNumber}}</p>
            </div>
        </div>
        <div class="row" v-show="FormInputs.ContactLegalName">
             <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <label class="account_label" v-if="FormInputs.BusinessLabels">Business/Practice Name:</label>
                <label class="account_label" v-else>Organization Name:</label>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                <div class="form-group">
                    <!-- <label v-if="FormInputs.BusinessLabels">Legal Business Name* (Participant)</label>
                    <label v-if="FormInputs.NonProfitLabels">Legal Organization Name* (Participant)</label>  -->
                    <p class="account_p">{{AccountEdit.primaryContact.legalName}}</p>
                    <!-- <input v-bind:class="{ error_field: ContactValidationResult.ContactLegalName }" v-model="AccountEdit.primaryContact.legalName" type="text" class="form-control input_field">
                    <p class="error-message" v-if="ContactValidationResult.ContactLegalName">{{ContactValidationResult.ContactLegalName}}</p> -->
                </div>
            </div>
        </div>
        <hr>
        <div class="row" v-if="FormInputs.BusinessLabels || FormInputs.NonProfitLabels">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <label class="account_label">Primary Contact:</label>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                <div class="row">                                                 
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group" v-show="FormInputs.ContactFirstName">
                            <label>First Name*</label>                                    
                            <input v-bind:class="{ error_field: ContactValidationResult.ContactFirstName }" v-model="AccountEdit.primaryContact.firstName" type="text" class="form-control input_field">
                            <p class="error-message" v-if="ContactValidationResult.ContactFirstName">{{ContactValidationResult.ContactFirstName}}</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group" v-show="FormInputs.ContactLastName">
                            <label>Last Name*</label>        
                            <input v-bind:class="{ error_field: ContactValidationResult.ContactLastName }" v-model="AccountEdit.primaryContact.lastName" type="text" class="form-control input_field">
                            <p class="error-message" v-if="ContactValidationResult.ContactLastName">{{ContactValidationResult.ContactLastName}}</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-5 col-sm-6 col-xs-6">
                        <div class="form-group" v-show="FormInputs.ContactSuffix">
                            <label>Suffix*</label>
                            <select v-bind:class="{ error_field: ContactValidationResult.ContactSuffix }" v-model="AccountEdit.primaryContact.suffix" class="form-control select_field">
                                <option v-for="(value, key) in Suffix" v-bind:value="key">{{key}}</option>
                            </select>
                            <p class="error-message" v-if="ContactValidationResult.ContactSuffix">{{ContactValidationResult.ContactSuffix}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                <!-- <label class="account_label" v-if="FormInputs.BusinessLabels || FormInputs.NonProfitLabels">Primary Phone:</label>
                <label class="account_label" v-else>Phone Number:</label> -->
            </div>
            <div class="col-lg-8 col-md-9 col-sm-12 col-xs-12">
                <div class="form-group" v-show="FormInputs.ContactPhoneNumber">
                    <label>Phone Number*</label>
                    <div class="row div-phone">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 sm">
                            <input ref="participant_number_1" type="text" maxlength="3" v-on:keypress="NumberCheck(this.event)" v-on:keyup="NextField(1)" v-bind:class="{ error_field: ContactValidationResult.ContactPhoneNumber }" v-model="AccountEdit.primaryContact.countryCode" class="form-control input_field">
                        </div>
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 sm">
                            <input ref="participant_number_2" type="text" maxlength="3" v-on:keypress="NumberCheck(this.event)" v-on:keyup="NextField(2)" v-bind:class="{ error_field: ContactValidationResult.ContactPhoneNumber }" v-model="AccountEdit.primaryContact.areaCode" class="form-control input_field">
                        </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 md">
                            <input ref="participant_number_3" type="text" maxlength="4" v-on:keypress="NumberCheck(this.event)" v-bind:class="{ error_field: ContactValidationResult.ContactPhoneNumber }" v-model="AccountEdit.primaryContact.phone" class="form-control input_field">
                        </div>
                    </div>     
                    <p class="error-message" v-if="ContactValidationResult.ContactPhoneNumber">{{ContactValidationResult.ContactPhoneNumber}}</p>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <label class="account_label">Participant Name:</label>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                <p class="account_p" v-if="(AccountEdit.primaryContact.suffix == 'N/A' ||  AccountEdit.primaryContact.suffix == '')">{{AccountEdit.primaryContact.firstName + " " + AccountEdit.primaryContact.lastName}}</p>
                <p v-else class="account_p">{{AccountEdit.primaryContact.firstName + " " + AccountEdit.primaryContact.lastName + ", " + AccountEdit.primaryContact.suffix}}</p>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                <!-- <label class="account_label" v-if="FormInputs.BusinessLabels || FormInputs.NonProfitLabels">Primary Phone:</label>
                <label class="account_label" v-else>Phone Number:</label> -->
            </div>
            <div class="col-lg-8 col-md-9 col-sm-12 col-xs-12">
                <div class="form-group" v-show="FormInputs.ContactPhoneNumber">
                    <label>Phone Number*</label>
                    <div class="row div-phone">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 sm">
                            <input ref="participant_number_1" type="text" maxlength="3" v-on:keypress="NumberCheck(this.event)" v-on:keyup="NextField(1)" v-bind:class="{ error_field: ContactValidationResult.ContactPhoneNumber }" v-model="AccountEdit.primaryContact.countryCode" class="form-control input_field">
                        </div>
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 sm">
                            <input ref="participant_number_2" type="text" maxlength="3" v-on:keypress="NumberCheck(this.event)" v-on:keyup="NextField(2)" v-bind:class="{ error_field: ContactValidationResult.ContactPhoneNumber }" v-model="AccountEdit.primaryContact.areaCode" class="form-control input_field">
                        </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 md">
                            <input ref="participant_number_3" type="text" maxlength="4" v-on:keypress="NumberCheck(this.event)" v-bind:class="{ error_field: ContactValidationResult.ContactPhoneNumber }" v-model="AccountEdit.primaryContact.phone" class="form-control input_field">
                        </div>
                    </div>     
                    <p class="error-message" v-if="ContactValidationResult.ContactPhoneNumber">{{ContactValidationResult.ContactPhoneNumber}}</p>
                </div>
            </div>
        </div>

        <div class="row" v-show="FormInputs.ContactRole">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                <div class="form-group">
                    <label v-if="FormInputs.BusinessLabels">Role in Business</label>
                    <label v-else>Role in Organization</label>
                    <select v-model="AccountEdit.primaryContact.title" class="form-control select_field" style="height: 36.5px;">
                        <option v-for="(value, key) in (FormInputs.RoleBusiness ? RoleBusiness : RoleNonProfit)" v-bind:value="value">{{key}}</option>
                    </select>                                     
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div class="form-group" v-show="FormInputs.ContactBusinessType">
                    <label v-if="FormInputs.IndividualLabels || FormInputs.BusinessLabels">Business Type <span v-bind:data-balloon="businessTypeTooltip" data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span></label>
                    <label v-else>Organization Type <span v-bind:data-balloon="organizationTypeTooltip" data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span></label>
                    <select v-model="AccountEdit.primaryContact.businessType" class="form-control select_field">
                        <option v-for="(value, key) in (FormInputs.BusinessTypeIndividual ? BusinessTypeIndividual : (FormInputs.BusinessTypeBusiness ? BusinessTypeBusiness : BusinessTypeNonProfit))" v-bind:value="value">{{key}}</option>
                    </select>
                </div>
            </div>
            
        </div>
      
    </div>               
</div>
</template>
<script>
export default {
  props: ['AccountEdit', 'AccountValidationResult', 'FormInputs', 'ContactValidationResult', 'Suffix', 
          'RoleNonProfit', 'RoleBusiness','BusinessTypeNonProfit', 'BusinessTypeBusiness', 
          'BusinessTypeIndividual', 'State'],
  methods:{
    NumberCheck(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();;
        } 
        // else {
        //     this.FocusNextField(this.$refs.participant_number_1, this.$refs.participant_number_2, this.$refs.participant_number_3);
        //     return true;
        // }
    },
        NextField(field){
        var focus1 = this.$refs.participant_number_1;
        var focus2 = this.$refs.participant_number_2;
        var focus3 = this.$refs.participant_number_3;

        if(field == 1 && focus1.value.length == 3){
             focus2.focus() ;
             }
        else if (field == 2 && focus2.value.length == 3){
            focus3.focus();
        }
    },
    FocusNextField(element1,element2,element3){
        if(element1.value.length == 2){
            element2.focus();   
        }
        else if (element2.value.length == 2){
            element3.focus();
        }
    },
    ValidateNpiNumber(npiNumber, event) {
      this.NumberCheck(event);
      var _this = this;
      if(npiNumber.length == 10){
        axios
        .get("/Account/IsNpiNumberValid/" + npiNumber)
        .then(response => {          
            _this.AccountValidationResult.AccountNpiNumber = response.data.errorMessage;
            _this.called = _this.AccountValidationResult.AccountNpiNumber; 
        })
        .catch(error => {
            console.log(error);
        });
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// EditAccountInfo.vue?c5035b70